export const isEmptyInputValue = (val: unknown): boolean => {
	return val === "" || val === "-" || val === undefined || val === null;
};
